import { HostSettingsState } from 'editor/src/store/hostSettings/types';
import { RootState } from 'editor/src/store/index';

function getHostSetting<T extends keyof HostSettingsState>(state: RootState, setting: T) {
  return state.hostSettings[setting];
}

export default getHostSetting;
